import { useMutation, useQuery } from "@tanstack/react-query";
import { DocEditLinkService } from "@/services/api/DocEditLinkService";
import { PublicDocEdit } from "@/types/knowledge";

/**
 * Public (no-login) hook powering the /update/:token page.
 * `data === null` means the token is invalid or revoked — render a branded 404.
 */
export const usePublicDocEdit = (token?: string) => {
  const query = useQuery<PublicDocEdit | null>({
    queryKey: ["public-doc-edit", token],
    queryFn: () => DocEditLinkService.getPublic(token as string),
    enabled: !!token,
    retry: false,
    staleTime: 0,
    gcTime: 0,
  });

  const save = useMutation({
    mutationFn: ({ content, pin }: { content: string; pin?: string }) =>
      DocEditLinkService.savePublic(token as string, content, pin),
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    save,
  };
};
